import {
	ChartContext,
	TimelineContext,
} from './timeline';
import { useContext } from 'react';

interface IProps {
	children: (chartContext: ChartContext) => any;
}

export function TimelineUseContext({ children }: IProps) {
	const chartContext = useContext(TimelineContext);
	return children(chartContext);
}
